/**
 * Oturumdaki ekip üyesi (crm_staff — Faz 1.1).
 * Satır yoksa (ör. ortak AdminEDEL hesabı) null döner; arayüz
 * o durumda kişiye özel olmayan varsayılanlarla çalışır.
 */
import { useEffect, useSyncExternalStore } from "react";
import { supabaseClient } from "../providers/supabase-client";
import type { CrmStaff } from "../types";

let cache: { uid: string; staff: CrmStaff | null } | null = null;
let inflight: Promise<void> | null = null;
const subs = new Set<() => void>();
const emit = () => subs.forEach((s) => s());

async function load() {
  const { data: auth } = await supabaseClient.auth.getUser();
  const uid = auth?.user?.id;
  if (!uid) return;
  if (cache?.uid === uid) return;
  const { data } = await supabaseClient
    .from("crm_staff")
    .select("*")
    .eq("profile_id", uid)
    .maybeSingle();
  cache = { uid, staff: (data as CrmStaff | null) ?? null };
  emit();
}

// Hesap değişince (çıkış / başka kullanıcıyla giriş) önbellek sıfırlanır.
supabaseClient.auth.onAuthStateChange((event) => {
  if (event === "SIGNED_OUT" || event === "SIGNED_IN" || event === "USER_UPDATED") {
    cache = null;
    inflight = null;
    emit();
  }
});

export function useStaff(): CrmStaff | null {
  const snapshot = useSyncExternalStore(
    (l) => {
      subs.add(l);
      return () => subs.delete(l);
    },
    () => cache?.staff ?? null
  );
  useEffect(() => {
    if (cache || inflight) return;
    inflight = load().finally(() => {
      inflight = null;
    });
  });
  return snapshot;
}
